module.exports = __webpack_public_path__ + "img/logo.b4e872c0.png";